import { useTranslation } from "react-i18next";
import React from "react";
import Stars from "./Stars";
import FindBikeButton from "./FindBikeButton";

const ResultItem = ({ item, traject, selectMtb }) => {
  const [t] = useTranslation("result");
  /*
  const bikefitClicked = () => {
    ReactGA.event({
      action: "click",
      category: "bikefit_list_start",
      label: "Start bikefit from list item",
      value: 0,
    });
    startBikefit();
  };
*/

  let rank = parseInt(item.rank, 10);
  return (
    <a
      key={item.rank}
      id={item.rank}
      className={"col-sm-4 optionr option-" + item.rank}
      onClick={() => selectMtb(item)}
    >
      <div className="option-inner text-center">
        {rank < 3 && <div className="option-number">{rank + 1}</div>}
        {rank === 0 && (
          <div className={"top top-" + rank}>{t("Beste Keus")}</div>
        )}
        <div className="top-wrap">
          <h3>{item.bike_model.brand + " " + item.bike_model.model}</h3>
          <img
            className="img-responsive"
            src={"/img/bikes/" + item.summary.image}
            alt={
              "Afbeelding " +
              item.bike_model.brand +
              " " +
              item.bike_model.model
            }
          />
        </div>
        <div className="bottom-wrap">
          <div className="info size">
            <strong>{t("Maat")}</strong>
            <br />
            {item.summary.bike_size === "NA"
              ? t("Result_NotApplicable")
              : item.summary.bike_size}
          </div>
          <div className="info price">
            <strong>{t("Adviesprijs")}</strong>
            <br />
            &euro;{item.summary.price.toLocaleString("nl")}
          </div>
          <div className="info weight">
            <strong>{t("Gewicht")}</strong>
            <br />
            {item.bike_model.weight
              ? Math.round(item.bike_model.weight / 100) / 10 + " kg"
              : t("Result_NotAvailable")}
          </div>
          <div className="info material">
            <strong>{t("Framemateriaal")}</strong>
            <br />
            {item.bike_model.frame_material
              ? item.summary.frame_material
              : t("Result_NotAvailable")}
          </div>
          <div className="info rank geofit">
            <strong>{t("Geometrische fit")}</strong>
            <br />
            {item.summary.fit !== null ? (
              <Stars number={Math.round(item.summary.fit / 10)} />
            ) : (
              t("Result_NotApplicable")
            )}
          </div>
          <div className="info rank gear">
            <strong>{t("Schakelsysteem")}</strong>
            <br />
            {item.summary.drive_chain !== null ? (
              <Stars number={Math.round(item.summary.drive_chain / 10)} />
            ) : (
              t("Result_NotApplicable")
            )}
          </div>
          {traject === "mtb" && (
            <div className="info rank suspension">
              <strong>{t("Vering")}</strong>
              <br />
              {item.summary.suspension !== null ? (
                <Stars number={Math.round(item.summary.suspension / 10)} />
              ) : (
                t("Result_NotApplicable")
              )}
            </div>
          )}
          <div className="info rank brake">
            <strong>{t("Remsysteem")}</strong>
            <br />
            {item.summary.brakes !== null ? (
              <Stars number={Math.round(item.summary.brakes / 10)} />
            ) : (
              t("Result_NotApplicable")
            )}
          </div>
          {traject === "race" && (
            <div className="info rank wheel">
              <strong>{t("Wielset")}</strong>
              <br />
              {item.summary.wheels !== null ? (
                <Stars number={Math.round(item.summary.wheels / 10)} />
              ) : (
                t("Result_NotApplicable")
              )}
            </div>
          )}
          <div className="info rank frame">
            <strong>{t("Framesterkte en -garantie")}</strong>
            <br />
            {item.summary.frame !== null ? (
              <Stars number={Math.round(item.summary.frame / 10)} />
            ) : (
              t("Result_NotApplicable")
            )}
          </div>
        </div>

          <FindBikeButton
            className={"post btn btn-secondary"}
            item={item}
            traject={traject}
            source={"list"}
          />

        <button
          className={"post btn btn-default gtm-" + traject + "-view-bike"}
          onClick={() => selectMtb(item)}
        >
          {t("Bekijk fiets")}
        </button>
        {/*
                    <button className="post btn btn-default"
                            onClick={() => selectMtb(item)}>Bekijk fiets
                    </button>

                    <button className="post btn btn-secondary"
                            onClick={() => goToStore(item)}>Koop fiets
                    </button>
                    */}
      </div>
    </a>
  );
};

export default ResultItem;
